import { Button, Modal, ScrollArea, Stack, Table, Text } from "@mantine/core";
import React from "react";
import { ZodIssue } from "zod";

export const ZodErrorModal: React.FC<{
  errors: ZodIssue[];
  onAbort: () => void;
}> = ({ errors, onAbort }) => {
  return (
    <Modal opened={true} onClose={onAbort} title="Feil" size="lg" centered>
      <Stack gap="md">
        <ZodErrorTable errors={errors} />
        <Button onClick={onAbort} style={{ alignSelf: "flex-end" }}>
          Lukke
        </Button>
      </Stack>
    </Modal>
  );
};

export const ZodErrorTable: React.FC<{ errors: ZodIssue[] }> = ({ errors }) => {
  const capitalizeFirstLetter = (str: string) => {
    if (typeof str === "string") {
      return str?.charAt(0).toUpperCase() + str?.slice(1);
    }
  };

  return (
    <ScrollArea h={360} type="auto">
      <Table striped highlightOnHover withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Hvor er det feil?</Table.Th>
            <Table.Th>Feilmelding</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {errors.map((error, index) => {
            const field =
              error.path.length > 0
                ? capitalizeFirstLetter(
                    typeof error.path[error.path.length - 1] === "number"
                      ? String(error.path[error.path.length - 2] ?? "")
                      : String(error.path[error.path.length - 1] ?? ""),
                  )
                : "";

            return (
              <Table.Tr key={`${error.path.join(".")}-${error.code}-${index}`}>
                <Table.Td>
                  <Text size="sm">{field || "-"}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{error.message}</Text>
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};
